import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import { object, string } from "yup";
import { Message } from "@qgiv/core-react";
import { Modal2 } from "@qgiv/core-donor";
import { submitSharingEmail } from "@qgiv/p2p-registration";
import ConnectedEmailSharingModalContent from "./ConnectedEmailSharingModalContent";

const EmailSharingModal = ({
    controlId,
    defaultMessageContent,
    defaultSubjectContent,
    emailModalOpen,
    alias,
    setAppEmailModalOpen,
    transactionId,
}) => {
    const dispatch = useDispatch();
    const [showMessage, setShowMessage] = useState(false);
    const [messageProps, setMessageProps] = useState({
        closeButton: true,
        onClose: () => {
            setShowMessage(false);
        },
    });

    return (
        <Formik
            initialValues={{
                Email_Address: "",
                Email_Message: defaultMessageContent,
                Email_Subject: defaultSubjectContent,
            }}
            validationSchema={object().shape({
                Email_Address: string()
                    .email(`Please enter a valid email.`)
                    .required(`Email is required.`),
                Email_Message: string().required(`Message is required.`),
                Email_Subject: string().required(`Subject is required.`),
            })}
            onSubmit={(values) => {
                submitSharingEmail(alias, {
                    ...values,
                    transactionId,
                })
                    .then((result) => {
                        const {
                            data: { message = ["Successfully sent"] },
                        } = result;
                        const formattedMessage = message.map((msg, i) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <p key={i}>{msg}</p>
                        ));
                        setMessageProps({
                            ...messageProps,
                            children: formattedMessage,
                            type: "success",
                        });
                    })
                    .catch(
                        ({
                            response: {
                                data: { errors = ["An error occurred."] },
                            },
                        }) => {
                            const formattedErrors = errors.map((err, i) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <p key={i}>{err}</p>
                            ));
                            setMessageProps({
                                ...messageProps,
                                children: formattedErrors,
                                type: "error",
                            });
                        },
                    )
                    .finally(() => {
                        setShowMessage(true);
                    });
            }}
        >
            {emailModalOpen && (
                <Modal2 onClose={() => dispatch(setAppEmailModalOpen(false))}>
                    {showMessage && (
                        <div className="-padding-left--20 -padding-right--20 -margin-top--10">
                            <Message {...messageProps} />
                        </div>
                    )}
                    <ConnectedEmailSharingModalContent controlId={controlId} />
                </Modal2>
            )}
        </Formik>
    );
};

EmailSharingModal.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    defaultMessageContent: PropTypes.string.isRequired,
    defaultSubjectContent: PropTypes.string.isRequired,
    emailModalOpen: PropTypes.bool.isRequired,
    alias: PropTypes.string.isRequired,
    setAppEmailModalOpen: PropTypes.func.isRequired,
    transactionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default EmailSharingModal;
